import { render, staticRenderFns } from "./MediaMatrixLayoutSetup.vue?vue&type=template&id=6c624f07&scoped=true"
import script from "./MediaMatrixLayoutSetup.vue?vue&type=script&lang=ts"
export * from "./MediaMatrixLayoutSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c624f07",
  null
  
)

export default component.exports